<template>
  <div class="st-social-buttons">
    <template v-if="user === null || (user && user.cidr !== 'corplan')">
      <figure
        v-if="isPremium"
        itemscope
        itemtype="http://schema.org/ImageObject"
        @click="onLoginClick"
      >
        <img
          :src="getLogoPath('st-avatar-white')"
          alt="st button login"
          title="st button login"
        />
      </figure>
      <div class="profile-menu" v-if="isPremium" v-show="expand">
        <div class="triangle-pointer"></div>
        <div
          class="profile-menu-item st-aologinid"
          v-if="user && user.aologinid"
        >
          Signed in as
          <span>{{ user.aologinid }}</span>
        </div>
        <!-- <div class="profile-menu-item st-logout-btn">
          <a :href="this.$premium.getLogoutUrl()">Log out</a>
        </div> -->
      </div>
    </template>
    <figure
      itemscope
      itemtype="http://schema.org/ImageObject"
      @click="shareFacebook"
    >
      <img
        :src="getLogoPath('st-button-facebook-white')"
        alt="st button facebook"
        title="st button facebook"
      />
    </figure>
    <figure
      itemscope
      itemtype="http://schema.org/ImageObject"
      @click="shareTwitter"
    >
      <img
        :src="getLogoPath('st-button-twitter-white')"
        alt="st button twitter"
        title="st button twitter"
      />
    </figure>
  </div>
</template>

<script>
/* globals FB */
import { mapState } from "vuex";

export default {
  props: ["colorTheme"],
  data() {
    return {
      expand: false,
    };
  },
  computed: {
    ...mapState(["meta", "user"]),
    isPremium() {
      return process.env.IS_PREMIUM;
    },
  },
  methods: {
    getLogoPath(name) {
      const whiteTheme = this.colorTheme !== "dark";
      return require(`images_base/${name}${whiteTheme ? "-white" : ""}.svg`);
    },
    onLoginClick() {
      if (!this.user) {
        window.location = this.$premium.getAuthorizationUrl();
      } else {
        this.expand = !this.expand;
      }
    },
    shareFacebook() {
      this.meta.forEach(meta => {
        if (meta.property && meta.property === 'og:url' && meta.content) {
          const patten = /XXXX|YYYY|XX|MM|localhost/g
          if (!patten.test(meta.content)) {
            window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(meta.content), 'sharer', '_blank')
            this.$analytics.getClient('social-share').track('click', 'fb-share', (global.isMobile) ? 'mobile' : 'desktop')
          }
        }
      })
      // FB.ui({
      //   method: 'feed',
      //   link: window.location.href
      // }, function (response) {})
    },
    shareTwitter() {
      this.meta.forEach((meta) => {
        if (meta.name) {
          if (meta.name === "twitter:description") {
            var textShare = meta.content.replace(new RegExp("#", "g"), "%23");
            textShare = textShare.replace(/'|’|‘/, "%27");
            var aUrl = this.findUrls(textShare);
            textShare = textShare.replace(aUrl[0], "", "g");
            window.open(
              "http://twitter.com/share?text=" + textShare + "&url=" + aUrl[0],
              "twitter",
              "_blank"
            );
            this.$analytics.getClient('social-share').track('click', 'twitter-share', (global.isMobile) ? 'mobile' : 'desktop')
          }
        }
      });
    },
    findUrls(text) {
      var source = (text || "").toString();
      var urlArray = [];
      var matchArray;
      // Regular expression to find FTP, HTTP(S) and email URLs.
      var regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&//=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g;
      // Iterate through any URLs in the text.
      while ((matchArray = regexToken.exec(source)) !== null) {
        var token = matchArray[0];
        urlArray.push(token);
      }
      return urlArray;
    },
  },
};
</script>
<style lang="scss">
.st-social-buttons {
  position: relative;
  display: block;

  figure {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 30px;
    vertical-align: middle;
    cursor: pointer;
    margin-left: 5px;

    @include breakpoint($d_menu_mobile) {
      width: 38px;
      height: 38px;

      img {
        opacity: 1;
      }

      &:hover {
        img {
          transform: scale(1);
        }
      }
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: transform 0.3s;
      transform: scale(0.9);
    }
  }

  .profile-menu {
    position: absolute;
    width: 180px;
    right: 0;
    background-color: #ffffff;
    color: $black;
    padding: 0 15px;
    font-family: $font-CuratorRegular;
    font-size: 15px;
    line-height: 26px;
    margin-top: 3.5px;
    border-radius: 3px;
    box-shadow: 0 0 3px rgba($black, 0.4);

    .triangle-pointer {
      position: absolute;
      top: -4px;
      right: 81px;
      border-bottom: 4px solid #ffffff;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;

      @media (min-width: $d_medium) {
        right: 101px;
      }
    }

    .profile-menu-item {
      white-space: normal;
      padding: 15px 0;
      line-height: 20px;
    }

    .st-aologinid {
      color: rgba($black, 0.8);

      span {
        display: block;
        font-family: $font-CuratorBold;
        color: $black;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .st-logout-btn {
      border-top: 1px solid rgba($black, 0.2);
      display: block;

      a {
        line-height: 11px;
        display: block;
        border-bottom: 0;
      }
    }
  }

  .st-content-shared-social & {
    position: static;

    .st-icon {
      opacity: 0.6;
    }

    &.expand {
      .st-icon {
        opacity: 1;
      }
    }

    .profile-menu {
      background-color: transparent;
      width: auto;
      bottom: 40px;
      left: 0;
      border-radius: 0;
      border-top: none;
      border-bottom: 1px solid #ffffff;
      margin-top: 0;
      margin-bottom: 3.5px;
      z-index: 1;
      max-width: 100%;

      .triangle-pointer {
        top: auto;
        bottom: -3px;
        border-bottom: none;
        border-top: 3px solid $stblue;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        right: 92px;

        &::before {
          content: "";
          border-bottom: none;
          border-top: 5px solid #ffffff;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          top: auto;
          bottom: -2px;
          left: -5px;
          z-index: -1;
        }
      }

      .st-aologinid,
      .st-aologinid span,
      .st-logout-btn a {
        color: rgba($black, 0.6);
      }

      .st-logout-btn {
        border-color: rgba(#b1b2b4, 0.2);
      }

      .st-aologinid span {
        display: inline;
        white-space: normal;
      }
    }
  }
}
</style>
